import React, { useState, useRef, useMemo, useEffect } from 'react'
import { Model } from 'survey-core'
import { Survey } from 'survey-react-ui'
// import 'survey-core/defaultV2.min.css'

import { useConvertSurvey } from '../hooks/useConvertSurvey'
import { useSubmitAnswers } from '../hooks/useSubmitAnswers'
import 'survey-core/i18n/traditional-chinese'

const Agree = ({
  setAc,
  setTk,
  ac,
  tk,
  pid,
  setIsLoading,
  setCompletionMessage,
}) => {
  const [myAgreeJson, setMyAgreeJson] = useState(null)
  // 需要登入嗎
  const requiresLogin = {
    login: false,
    title: '員工編號（邁達特：MA、啟迪：GI、聚上雲：EP、逐鹿：GU）',
    placeholder: 'MA00000',
    alert: '員工編號有誤，請重新登入，謝謝',
  }
  const [imagesReadingTime, setImagesReadingTime] = useState(0)
  const canShowPrevButtonPages = null
  const choicesOrderRef = useRef({})
  const choiceIndexMapRef = useRef({})
  // const bringOptionsMapRef = useRef({})
  // 圖片閱讀時間(秒)
  // useEffect(() => {
  //   setImagesReadingTime(30)
  // }, [])
  const completedHtml = `<h3>問卷正在提交中，請稍候。</h3><h3>請在成功頁面顯示後再離開。</h3><h4>如有填卷相關問題請洽：</h4> <a href='https://lin.ee/HWETcqy'>https://lin.ee/HWETcqy</a><h4 style='margin-top:50px'>填寫其他問卷：</h4> <a href=${window.location.origin}>${window.location.origin}</a>`

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const agreeSurvey = new Model(myAgreeJson)

  // 問卷編號
  // const pid = pid
  // 跳題 小心複選題要用陣列

  // const visibleIfConditionsInit = {
  //   q6: '{q5} = 0 or {q5} = 1 or {q5} = 2 or {q5} = 3',
  //   q7: '{q6} = ["none"]',
  //   q36: `{q35} <> ['none']`,
  // }

  //受僱者
  const Employee = '{q7} = 0 or {q8} = 0'
  //自僱者
  const selfEmployed = '{q7} = 1 or {q8} = 1'

  const visibleIfConditionsInit = {
    q3: '{q2} = 1',
    q4: '{q2} = 1',
    q8: '{q7} = 2 or {q7} = 3',
    q9: '{q7} = 1 or ({q7} = 2 and {q8} = 1) or ({q7} = 3 and {q8} = 1)',
    q10: Employee,
    q11: Employee,
    q12: '{q11} = 1 or {q11} = 2',
    q13: '{q12} = 0',
    q14: '{q12} = 1',
    q15: '{q12} = 2',
    q16: Employee,
    q17: '{q16} = 0',
    q18: '{q16} = 0 and {q17} = 0',
    q19: '{q16} = 0 and {q17} = 1',
    q20: '{q16} = 1 or {q16} = 2 or ({q16} = 0 and {q17} = 2) or ({q16} = 0 and {q17} = 3)',
    q24: '{q23} = 1 or {q23} = 2 or {q23} = 3 or {q23} = 4 or {q23} = 5 or {q23} = 6 or {q23} = 7',
    q26: '{q25} = 0',
    q27: '{q25} = 0 or {q25} = 1',
    q29: '{q28} = 0',
    q30: '{q28} = 1',
    q32: '{q31} = 0',
    q33: '{q31} = 1',
    q35: '{q34} = 0',
    q36: '{q34} = 1',
    q38: '{q1} = 0 or {q1} = 4 or {q1} = 6 or {q1} = 7',
    q39: '{q1} = 1 or {q1} = 2 or {q1} = 8 or {q1} = 11',
    q40: '{q1} = 3 or {q1} = 5 or {q1} = 9 or {q1} = 10',
    q41: '{q1} = 4 or {q1} = 5 or {q1} = 6 or {q1} = 7',
    q42: '{q1} = 0 or {q1} = 1 or {q1} = 2 or {q1} = 3',
    q43: '{q1} = 8 or {q1} = 9 or {q1} = 10 or {q1} = 11',
    q44: Employee,
    q45: selfEmployed,
    q50: '{q44} = 0 or {q44} = 1 or {q45} = 0 or {q45} = 1 or {q46} = 0 or {q46} = 1 or {q49} = 0 or {q49} = 1',
    q51: '{q48} = 0 or {q48} = 1 or {q48} = 2',
    q53: '{q52} = 0',
    q54: '{q48} = 1 or {q48} = 2 or {q48} = 3 or {q48} = 4 or {q48} = 5 or {q48} = 6',
    q55: '{q54} = 0 or {q54} = 1 or {q54} = 2 or {q54} = 3 or {q54} = 5 or {q54} = 6 or {q54} = 7',
    q56: '{q55} = 0',
    q57: '{q55} = 1',
    q58: '{q55} = 2',
    q65: '{q64} = 0',
    q67: '{q66} = 0 or {q66} = 1',
    q70: '{q0} = 0 or {q0} = 2 or {q0} = 4',
    q71: '{q0} = 1 or {q0} = 3 or {q0} = 5',
    q72: Employee,
    q79: '{q78} = 0 or {q78} = 1',
    q80: '{q79} = 0 or {q79} = 1',
    q81: '{q80} = 0 or {q80} = 1',
    q82: '({q7} = 0 or {q8} = 0) and ({q76} = 0 or {q76} = 1 or {q76} = 2 or {q76} = 3 or {q76} = 4 or {q76} = 5 or {q77} = 0 or {q77} = 1 or {q77} = 2 or {q77} = 3 or {q77} = 4 or {q77} = 5 or {q78} = 0 or {q79} = 0 or {q80} = 0 or {q81} = 0)',
    q83: '{q76} = 0 or {q76} = 1 or {q76} = 2 or {q76} = 3 or {q76} = 4 or {q76} = 5 or {q77} = 0 or {q77} = 1 or {q77} = 2 or {q77} = 3 or {q77} = 4 or {q77} = 5 or {q78} = 0 or {q79} = 0 or {q80} = 0 or {q81} = 0',
    q87: '{q84} = 0 or {q84} = 1 or {q86} = 0 or {q86} = 1',
    q90: '{q1} = 0 or {q1} = 2 or {q1} = 4 or {q1} = 6 or {q1} = 8 or {q1} = 10',
    q91: '{q1} = 1 or {q1} = 3 or {q1} = 5 or {q1} = 7 or {q1} = 9 or {q1} = 11',
    q93: '{q92} = 0 or {q92} = 1 or {q92} = 2',
    q96: selfEmployed,
    q97: Employee,
    q98: selfEmployed,
    q99: Employee,
    q100: Employee,
    q101: Employee,
    q102: selfEmployed,
    q103: Employee,
    q109: Employee,
    q117: Employee,
    q118: '({q0} = 0 or {q0} = 1 or {q0} = 2) and ({q117} = 0 or {q117} = 1 or {q117} = 2)',
    q119: '({q0} = 3 or {q0} = 4 or {q0} = 5) and ({q117} = 0 or {q117} = 1 or {q117} = 2)',
    q123: Employee,
    q124: selfEmployed,
    q126: '{q123} = 1',
    q127: '{q123} = 0 or {q124} = 0 or {q125} = 0',
    q129: '{q128} = 0',
    q130: '({q1} = 0 or {q1} = 1 or {q1} = 2 or {q1} = 3 or {q1} = 4 or {q1} = 5) and ({q129} = 0 or {q129} = 1)',
    q131: '({q1} = 6 or {q1} = 7 or {q1} = 8 or {q1} = 9 or {q1} = 10 or {q1} = 11) and ({q129} = 0 or {q129} = 1)',
    q132: '{q129} = 0 or {q129} = 1',
    q133:
      '({q1} = 0 or {q1} = 2 or {q1} = 4 or {q1} = 6 or {q1} = 8 or {q1} = 10) and ' +
      Employee,
    q134:
      '({q1} = 1 or {q1} = 3 or {q1} = 5 or {q1} = 7 or {q1} = 9 or {q1} = 11) and ' +
      Employee,
    q135: '({q0} = 0 or {q0} = 2 or {q0} = 4) and ' + Employee,
    q136: '({q0} = 1 or {q0} = 3 or {q0} = 5) and ' + Employee,
    q140: '{q139} = 0 or {q139} = 1',
    q141: '{q0} = 0 or {q0} = 1 or {q0} = 2',
    q142: '{q0} = 3 or {q0} = 4 or {q0} = 5',
    q146: '{q145} = 0',
    q152: '({q7} = 0 or {q8} = 0) and ({q139} = 0 or {q140} = 0 or {q140} = 1 or {q143} = 0)',
    q153: Employee,
    q154: '{q1} = 0 or {q1} = 2 or {q1} = 4 or {q1} = 6 or {q1} = 8 or {q1} = 10',
    q155: '{q1} = 1 or {q1} = 3 or {q1} = 5 or {q1} = 7 or {q1} = 9 or {q1} = 11',
    q159: Employee,
    q165: '{q0} = 0 or {q0} = 2 or {q0} = 4',
    q166: '{q0} = 1 or {q0} = 3 or {q0} = 5',
    q169: Employee,
    q172: '{q171} = 4 or {q171} = 5 or {q171} = 6 or {q171} = 7',
    q173: '{q171} = 0 or {q171} = 1 or {q171} = 2 or {q171} = 3',
    q174: '{q171} = 4 or {q171} = 5 or {q171} = 6 or {q171} = 7',
    q178: '{q175} = 0',
    q179: '{q178} = 0',
    q180: '{q178} = 1',
    q181: '{q176} = 0',
    q182: '{q181} = 0',
    q183: '{q181} = 1',
    q184: '{q177} = 0',
    q185: '{q184} = 0',
    q186: '{q184} = 1',
    q187: '{q175} = 1 or {q175} = 2',
    q188: '{q187} = 0',
    q189: '{q187} = 1',
    q190: '{q176} = 1 or {q176} = 2',
    q191: '{q190} = 0',
    q192: '{q190} = 1',
    q193: '{q177} = 1 or {q177} = 2',
    q194: '{q193} = 0',
    q195: '{q193} = 1',
    q199: Employee,
    q201: selfEmployed,
    q203: '{q202} = 0',
    q204: '{q202} = 1',
    q205: '{q202} = 2',
    q206: '{q202} = 3 or {q202} = 4',
    q207: '{q206} = 0',
    q208: '{q206} = 1',
    q209: '{q206} = 2',
    q211: `{q210} = 'other'`,
    q212: `{q210} = 'other'`,
    q213: `{q210} = 'other'`,
    q214: `{q210} = 'other'`,
    q215: `{q210} = 'other'`,
    q216: `{q210} = 'other'`,
    q217: `{q210} = 'other'`,
    q218: `{q210} = 'other'`,
    q219: `{q210} = 'other'`,
    q220: `{q210} = 'other'`,
  }
  // const visibleIfConditionsInit = null
  // const pageVisibleIfConditionsInit = null

  // 非必填(從 0 計算)
  // const notRequired = [100]
  const notRequired = null

  const mappedRateChoice = null
  // const pageBreakQuestions = ['q6', 'q11', 'q15']
  const pageBreakQuestions = null

  const triggersConditionsInit = [
    // {
    //   type: 'complete',
    //   expression: `({q1} = 1) or ({q2} = 0)`,
    // },
  ]
  // const triggersConditionsInit = null
  // const pageVisibleIfConditionsInit = null

  const convertedSurvey = useConvertSurvey({
    survey: agreeSurvey,
    pid,
    setAc,
    setTk,
    ac,
    tk,
    setMyAgreeJson,
    imagesReadingTime,
    setImagesReadingTime,
    setIsLoading,
    completedHtml,
    visibleIfConditionsInit,
    notRequired,
    mappedRateChoice,
    pageBreakQuestions,
    requiresLogin,
    triggersConditionsInit,
    // bringOptionsMapRef,
  })

  // const newSurvey = new Model(convertedSurvey)

  const surveyModel = useMemo(() => {
    if (!convertedSurvey) return null
    return new Model(convertedSurvey)
  }, [convertedSurvey])

  // useEffect(() => {
  //   console.log('convertedSurvey', convertedSurvey)
  // }, [convertedSurvey])

  // const endMessage = `很抱歉，目前與您相同特性的樣本已經額滿，沒辦法參與本次活動。歡迎您分享本問卷連結給其他親朋好友，或加入我們的<a href='https://lin.ee/HWETcqy'>LINE@</a>，隨時得到最新填問卷獲好禮的消息。<p>請按「完成」前往下載 EZChoice 或填寫更多問卷</p>`

  function helpFunction(survey, options) {
    // console.log('survey.getValue(q42)', survey.getValue('q42'))
    // 參考 P231113152849 或 P231101165555 或 P231206105643(政大帶入選項)
  }

  // const endSurveyMsg = (survey) => {
  //   if (survey.getValue('q1') === 1 || survey.getValue('q2') === 0) {
  //     setCompletionMessage(endMessage)
  //   } else {
  //     setCompletionMessage(
  //       `<h4 style='text-align: center'>問卷已成功送出</h4><h4 style='text-align: center'>請按「完成」前往下載 EZChoice 或填寫更多問卷</h4>`
  //     )
  //   }
  // }

  // useEffect(() => {
  //   console.log('bringOptionsMapRef', bringOptionsMapRef)
  // }, [bringOptionsMapRef])

  useSubmitAnswers({
    survey: surveyModel,
    pid,
    ac,
    tk,
    imagesReadingTime,
    setIsLoading,
    helpFunction,
    canShowPrevButtonPages,
    choicesOrderRef,
    choiceIndexMapRef,
    // endSurveyMsg,
    // bringOptionsMapRef,
  })

  return (
    <>
      {surveyModel ? (
        <Survey model={surveyModel} key={pid} />
      ) : myAgreeJson ? (
        <Survey model={agreeSurvey} />
      ) : (
        <></>
      )}
    </>
  )
}

export default Agree
